import { Component } from '@theme/component';

const selectors = {
  TEMPLATE: 'template',
  DRAWER: '#shop-the-look',
  DRAWER_BODY: '.dialog-drawer__body',
  COUNT: '[data-selector="product-count"]',
};

class ShopTheLook extends Component {
  /** @returns {import('@theme/dialog').DialogComponent | null} */
  get #dialogComponent() {
    return this.querySelector(selectors.DRAWER);
  }

  /**
   * @param {{ target: HTMLElement }} event
   */
  openDrawer({ target }) {
    const template = /** @type {HTMLTemplateElement | null} */ (
      target.querySelector(selectors.TEMPLATE)
    );
    const dialog = this.#dialogComponent;

    if (!template || !dialog) return;

    const body = dialog.querySelector(selectors.DRAWER_BODY);
    const count = dialog.querySelector(selectors.COUNT);

    if (count) count.textContent = target.dataset.count || '';
    if (body) body.replaceChildren(document.importNode(template.content, true));

    dialog.showDialog();
  }
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLook);
}
